export default "<div class=\"map-responsive\">\r\n    <div class=\"map-window\" [ngStyle]=\"{'height':mapHight}\" id=\"live-tracking\"></div>\r\n</div>";